<template>
	<div class="container">
		<loader v-show="pageLoader"></loader>
		<alert-notification v-if="notification_msg != ''"/>
		<div class="row justify-content-center">
			<div class="col-12 col-lg-6" v-if="div_section == ''">
				<div class="api-accesss-tocken">
					<div class="modPic">
						<img src="../../../../static/website/images/Placeholder-pana.svg" alt="icon">
					</div>
					<div v-if="parseInt(get_user.api_status) == 1">
						<div class="d-flex align-items-end mob-wrap">
							<div class="form-group mb-0 w-100">
								<label class="getToken">API Key</label>
								<div class="position-relative">
									<input class="form-control" type="text" placeholder=" " name="text" v-model="api_key"  readonly />
									<label class="labeltext" v-if="api_key == ''">Hidden for security reasons</label>
								</div>
							</div>
							 <div class="switchButton ml-2 d-flex align-items-center">
							 	<div class="copied"  v-if="copy_msg1">
									<span>Copied</span>
								</div>
								<button class="cap_btn blue justify-content-center d-flex align-items-center mr-2 circle1" :class="[{'disabled':api_key == ''}]" @click="keytype = '1'" v-clipboard:copy="api_key" v-clipboard:success="onCopy" v-clipboard:error="onError">
									<feather size="16px" type="copy" class="mr-1"></feather> Copy
								</button>
							</div>
						</div>
						<div class="d-flex align-items-end mob-wrap">
							<div class="form-group mb-0 w-100">
								<label class="getToken">Client Secret Key </label>
									<div class="position-relative">
									<input class="form-control" type="text" placeholder=" " name="text" v-model="client_secret_key" readonly />
									<label class="labeltext" v-if="client_secret_key == ''">Hidden for security reasons</label>
								</div>
							</div>
							<div class="switchButton ml-2 d-flex align-items-center">
								<div class="copied"  v-if="copy_msg2">
									<span>Copied</span>
								</div>
								<button class="cap_btn blue justify-content-center d-flex align-items-center mr-2 circle1" :class="[{'disabled':client_secret_key == ''}]" @click="keytype = '2'" v-clipboard:copy="client_secret_key" v-clipboard:success="onCopy" v-clipboard:error="onError">
									<feather size="16px" type="copy" class="mr-1"></feather> Copy
								</button>
							</div>
						</div>
						<div class="genrateNew_show d-flex text-left mt-3">
							<a class="cap_btn blue justify-content-center d-flex align-items-center" href="#" @click="selectDivFunc(false) "><feather size="16px" type="eye" class="mr-1"></feather> Show</a>
						</div>
						<div class="genrateNew text-left mt-3" >
						   <p>If you want to update API key please click here <a href="#" @click="selectDivFunc(true)">Update API Key</a> </p>
						</div>
					</div>
					<div class="genrateNew text-center mt-3" v-if="parseInt(get_user.api_status) == 0">
					   <p>If you want to generate new API key please click here</p><p><a class="cap_btn blue" href="#" @click="selectDivFunc(true)">Generate New Api</a> </p>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6" v-else-if="div_section == 1 && parseInt(get_user.profile.gAuthenticatorEnabled) == 0">
				<div class="modal-body customModalSecurity">
				<app-twofa :call_from="'api_key'" v-if="two_fa" class="withdrawalAllow"></app-twofa>
					<div class="text-center"v-else>
						<div class="icoDisable">
									<img src="../../../../static/website/images/4112331.svg" alt="IconAPP">
								</div>

						<div class="authenticationApp">
							 <p> Two factor authentication is disabled on your account. And as a security measure, we cannot process withdrawals unless 2FA is enabled.</p><p> <a class="px-3 cap_btn blue" @click="two_fa = true" href="#">Enable 2fa</a></p>
						</div>
						
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6" v-else-if="div_section == 2 && parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
				<div class="OTPValidation text-center p-3">
				<div class="icoDisable">
									<img src="../../../../static/website/images/4112331.svg" alt="IconAPP">
								</div>
					<p>You’ll now be required to enter both your password and the authentication code to log in to your secure client area.</p>
					<div class="d-flex align-items-center mob">
					<div class="form-group w-100">
						<input type="text" class="form-control" autocomplete="off" name="otp" required="" placeholder=" " v-model="otp" maxlength="6" v-validate="'required|numeric|max:6'" @keyup.enter="generateApiKey()"/>
						<label class="labeltext">Enter Google Authenticator Otp</label>
						<span v-if="submitted && errors.has('otp')" class="text-danger">{{ errors.first('otp') }}</span>
					</div>
					<div class="form-group">
						<a class="cap_btn blue ml-2 min-42" @click="generateApiKey()" href="#">Submit</a>
					</div>
				</div>
				</div>
			</div>
		</div>
		
	</div>
</template>
<script>
	import TwoFa from '../security/security'
	export default {
		name: 'wallets',
		data() {
			return {
				pageLoader : false,
				notification_msg:'',
            	notification_type:'',
            	copy_msg1:'',
            	copy_msg2:'',
            	keytype:'',
				client_secret_key : '',
				api_key : '',
				
				updateApi : false,
				
				div_section : '',
				two_fa : false,
				otp : '',
				submitted : false
			}
		},
		components:{
			appTwofa : TwoFa
		},
		methods:{
			selectDivFunc(getData){
				this.updateApi = getData
				if(parseInt(this.get_user.profile.gAuthenticatorEnabled) == 0){
					this.div_section = 1
				}else{
					this.div_section = 2
				} 
			},
			clear(){				
				this.updateApi = false				
				this.div_section = ''
				this.two_fa = false
				this.otp = ''
				this.submitted = false
			},
			generateApiKey(){
				const _that = this
	            _that.submitted = true;
	            _that.$validator.validate().then(valid => {
	                if (valid) {
						if(_that.updateApi){
							_that._runUpdateApiKey(
								{ 'globalParams' :{ 
									otp : _that.otp,
									type : 'KEYS'
								},'localParams' :{"parameter" : _that}}
							)
						}else{
							_that._runGetApiKeys(
								{ 'globalParams' :{ 
									type : 'keys',
									otp : _that.otp
								},'localParams' :{"parameter" : _that}}
							)
						}
	                	
	                }
	            })
			},
			onCopy(e) {
			    var _that = this
			    if(this.keytype == '1'){
			    	this.copy_msg1 = true
			    }else{
			    	this.copy_msg2 = true
			    }
				setTimeout(function() { 
					_that.copy_msg1 = false
					_that.copy_msg2 = false
					// $(".copied").fadeOut(1500); 
				}, 2000)
				
            },
            onError(e) {
			    var _that = this
				try{
			        _that.notification_msg = 'Address not Copied' ;
			        _that.notification_type = 'error' ;

			        setTimeout(function(){
			            _that.notification_msg = '' ;
			            _that.notification_type = '' ;
			        }, 5000);
			    }catch(e){}
            }
		},
		created(){
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/website/api-access/api_key.vue